import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { setToken, setUserInfo } from '@/utils/auth';
import AuthService from '@/services/amai/auth.service';
import { eventBus } from '@/utils/eventBus';

/**
 * Ticket处理组件
 * 职责：在非AuthGuard保护的路由中（如/home）处理URL中的ticket参数，
 * 静默兑换Token并写入本地存储。
 */
const TicketProcessor: React.FC = () => {
  const location = useLocation();
  const processedTicketRef = useRef<string | null>(null);
  const isProcessingRef = useRef(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const ticket = urlParams.get('ticket');

    if (!ticket || processedTicketRef.current === ticket || isProcessingRef.current) return;

    isProcessingRef.current = true;
    console.log('[TicketProcessor] 发现ticket，开始兑换Token...');

    AuthService.getTokenByTicket(ticket)
      .then(response => {
        if (response.code === 0 && response.data?.token) {
          setToken(response.data.token);
          setUserInfo({
            user_id: response.data.user_id,
            user_name: response.data.user_name,
            user_avatar: response.data.user_avatar,
            mobile: response.data.mobile,
          });
          processedTicketRef.current = ticket;
          const userInfoPayload = {
            user_id: response.data.user_id,
            user_name: response.data.user_name,
            user_avatar: response.data.user_avatar,
            mobile: response.data.mobile,
          };
          eventBus.emit('userInfoUpdated', userInfoPayload);

          const url = new URL(window.location.href);
          url.searchParams.delete('ticket');
          window.history.replaceState({}, '', url.toString());
          console.log('[TicketProcessor] Token兑换成功。');
        } else {
          console.warn('[TicketProcessor] Token兑换失败:', response.message);
        }
      })
      .catch(error => {
        console.error('[TicketProcessor] 请求异常:', error);
      })
      .finally(() => {
        isProcessingRef.current = false;
      });
  }, [location.search]);

  return null;
};

export default TicketProcessor;
